import styled from 'styled-components';
import { fontTitle, fontBody } from 'Styles/fonts';
import breakpoint from 'Styles/breakpoints';
import Icon from '../../../Icons/Icon';

export const CouponDialogSmsSuccess = styled.div`
  margin: 0 auto;
  text-align: center;
  ${breakpoint('medium')} {
    width: 334px;
  }
`;

export const SmsBodyHeading = styled.div`
  ${fontTitle(24)};
  margin-bottom: 4px;
`;

export const Main = styled.div`
  margin-bottom: 24px;
`;

export const Subheader = styled.div`
  ${fontTitle(16)}
  margin-bottom: 8px;
`;

export const SmsBodyText = styled.div`
  ${fontBody(14)};
`;

export const SmsIcon = styled(Icon).attrs({
  name: 'sms',
  size: 103
})`
  margin-bottom: 24px;
  color: var(--foreground);
`;
